export default "__VITE_ASSET__De2Tzv5G__"